export default __webpack_public_path__ + "static/media/46.c095a8bb.svg";